import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const UserCopySelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("UserCopySelect", true))
);

export default UserCopySelectMultipleTester;
